// A pure, deterministic relative-time formatter shared across the Git views
// (extracted from the retired HistoryView). Formats a unix-seconds timestamp as
// a short relative string ("3 days ago"); past one year it falls back to a short
// absolute date so old commits read clearly. `nowMs` is injectable for tests.

export function relativeTime(unixSeconds: number, nowMs: number = Date.now()): string {
  const deltaSec = Math.round(nowMs / 1000 - unixSeconds);
  const abs = Math.abs(deltaSec);
  const YEAR = 31_557_600; // 365.25 days
  if (abs >= YEAR) {
    return new Date(unixSeconds * 1000).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'always' });
  // Past commits are negative for RelativeTimeFormat (yields "... ago").
  const sign = deltaSec >= 0 ? -1 : 1;
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['year', YEAR],
    ['month', 2_629_800], // YEAR / 12
    ['week', 604_800],
    ['day', 86_400],
    ['hour', 3_600],
    ['minute', 60],
    ['second', 1],
  ];
  for (const [unit, secs] of units) {
    if (abs >= secs || unit === 'second') {
      return rtf.format(Math.round(abs / secs) * sign, unit);
    }
  }
  return rtf.format(0, 'second');
}
